import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import FormulaField from 'features/common/components/formula-field';
import { FormulaFieldLabel, FormulaFieldContainer } from 'components/common/Styles';

const CompetenceOrderRuleListItemComponent = ({
  competenceOrderRule,
  approvalTypeLevels,
  ruleStatuses,
  index,
  onPropertyChanged,
  collectionValidation
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Grid item container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            isNumeric
            fullWidth
            value={competenceOrderRule.orderId}
            onChange={event => onPropertyChanged('orderId', event, index)}
            label={t('CompetenceOrder.Rule.OrderId')}
            error={!isValid(collectionValidation[index].orderId)}
            helperText={getErrors(collectionValidation[index].orderId)}
            decimalScale={0}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Autocomplete
            fullWidth
            isClearable={false}
            labelKey='levelName'
            valueKey='approvalTypeLevelId'
            value={{
              approvalTypeLevelId: competenceOrderRule.approvalTypeLevelId,
              levelName: competenceOrderRule.levelName
            }}
            options={approvalTypeLevels}
            onChange={event => {
              onPropertyChanged('approvalTypeLevelId', event ? event.approvalTypeLevelId : null, index);
              onPropertyChanged('levelName', event ? event.levelName : null, index);
            }}
            label={t('CompetenceOrder.Rule.LevelName')}
            error={!isValid(collectionValidation[index].approvalTypeLevelId)}
            helperText={getErrors(collectionValidation[index].approvalTypeLevelId)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Autocomplete
            fullWidth
            isClearable={false}
            labelKey='statusName'
            valueKey='statusId'
            value={{ statusId: competenceOrderRule.ruleStatusId, statusName: competenceOrderRule.ruleStatusName }}
            options={ruleStatuses}
            onChange={event => {
              onPropertyChanged('ruleStatusId', event ? event.statusId : null, index);
              onPropertyChanged('ruleStatusName', event ? event.statusName : null, index);
            }}
            label={t('CompetenceOrder.Rule.RuleStatusName')}
            error={!isValid(collectionValidation[index].ruleStatusId)}
            helperText={getErrors(collectionValidation[index].ruleStatusId)}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormulaFieldLabel error={!isValid(collectionValidation[index].expression)} required>
            {t('CompetenceOrder.Rule.Expression')}
          </FormulaFieldLabel>
          <FormulaFieldContainer>
            <FormulaField
              formulaLabel={t('CompetenceOrder.Expression')}
              value={competenceOrderRule.expression}
              onChange={event => onPropertyChanged('expression', event, index)}
            />
          </FormulaFieldContainer>
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormulaFieldLabel error={!isValid(collectionValidation[index].decisionFormula)}>
            {t('CompetenceOrder.Rule.DecisionFormula')}
          </FormulaFieldLabel>
          <FormulaFieldContainer>
            <FormulaField
              formulaLabel={t('CompetenceOrder.Rule.DecisionFormula')}
              value={competenceOrderRule.decisionFormula}
              onChange={event => onPropertyChanged('decisionFormula', event, index)}
            />
          </FormulaFieldContainer>
        </Grid>
      </Grid>
    </>
  );
};

CompetenceOrderRuleListItemComponent.propTypes = {
  competenceOrderRule: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  approvalTypeLevels: PropTypes.array,
  ruleStatuses: PropTypes.array,
  onPropertyChanged: PropTypes.func.isRequired,
  collectionValidation: PropTypes.object.isRequired
};
export default CompetenceOrderRuleListItemComponent;
